// #ux-redesign-start: DoctorList rediseñada (Paso 7 — Patients)
import React from "react";
import { useTranslate } from "react-translate";

import { PageContainer } from "components/ds";
import DoctorListComponent from "components/Doctors/DoctorListComponent";

const DoctorList = () => {
  const t = useTranslate("doctors");
  return (
    <PageContainer title={t("doctors")} icon="user-active">
      <DoctorListComponent />
    </PageContainer>
  );
};

export default DoctorList;
// #ux-redesign-end
